<template>
  <v-layout column v-if="keywordsSectionState.showSection">
    <SearchAISubtitle
      :title="$t('ai.keywords.title')"
      :hasEdit="!keywordsSectionState.showHintBar"
      @onEditClick="handleEditClick"
    ></SearchAISubtitle>
    <v-layout flex column align-center v-if="keywordsSectionState.isLoading" class="mb-4 mt-1">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="36">
      </v-progress-circular>
      <span class="mt-2 keywords-container-loading-text" v-html="$t('ai.keywords.loadingText')"></span>
    </v-layout>
    <v-layout row wrap class="ml-5">
      <KeywordsGroup
        class="mr-3 mb-3"
        v-if="!keywordsSectionState.isLoading"
        v-for="contents in keywords"
        :group-word="Object.keys(contents)[0]"
        :groupSelectedState="contents[Object.keys(contents)[0]].selectedState"
        :terms="contents[Object.keys(contents)[0]].terms"
        :key="Object.keys(contents)[0]"
        :isCollapsed="isCollapsedCheck"
        @selectAllClick="handleSelectAllClick"
      ></KeywordsGroup>
    </v-layout>
<!--    <p v-if="showRateLimitMsg">{{ $t('ai.keywords.rateLimitMessage') }}</p>-->
    <HintBar class="ml-5 keywords-container-hint-bar" v-if="keywordsSectionState.showHintBar && !keywordsSectionState.isLoading">
      <div slot="content">
        <i18n path="ai.keywords.hintBar.text" class="hint-bar-content hint-text">
          <template v-slot:select>
            <CheckboxTag :text="$t('ai.keywords.hintBar.select')" type="checkbox" color="blue" :animated="false"></CheckboxTag>
          </template>
          <template v-slot:selectAll>
            <CheckboxTag :text="$t('ai.keywords.hintBar.selectAll')" :selected="false" type="checkbox" :animated="false"></CheckboxTag>
          </template>
        </i18n>
      </div>
    </HintBar>
  </v-layout>
</template>

<script>
import KeywordsGroup from '../utils/KeywordsGroup.vue'
import {HintBar} from '../utils'
import SearchAISubtitle from './SearchAISubtitle.vue'
import {CheckboxTag} from '../utils/buttons'
export default {
  name: 'KeywordsContainer',
  components: { CheckboxTag, SearchAISubtitle, HintBar, KeywordsGroup },
  computed: {
    keywords: { get () { return this.$store.getters.getRelevantKeywordsOrdered } },
    keywordsSectionState: { get () { return this.$store.getters.getKeywordsSectionState } },
    isCollapsedCheck: { get () { return this.$store.getters.getContentGenerated } }
    // showRateLimitMsg: { get () { return this.$store.getters.isRateLimitHit } }
  },
  methods: {
    handleEditClick () {
      this.$store.dispatch('updateAiState', 2)
    },
    handleSelectAllClick (groupWord, newGroupState) {
      this.$store.commit('updateRelevantKeywordsGroupState', {groupWord, newGroupState})
    }
  }
}
</script>

<style lang="scss" scoped>
.keywords-container {
  &-loading-text {
    text-align: center;
  }
  &-hint-bar {
    position: sticky;
    bottom: 80px;
  }
}
.slot-wrapper > div > span {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/searchAi/KeywordsContainer.vue